"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("utils/components");
const auth_1 = require("common/auth");
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../helpers");
const dataTransferSchema_1 = __importDefault(require("../../dataTransferSchema"));
const schema_1 = __importDefault(require("./schema"));
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const schemaComponents_1 = require("@/schemaComponents");
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
const models_hook_1 = require("app/models.hook");
const index_1 = require("../../../../../../index");
const standard_1 = require("react-hook-schema/standard");
function SegmentRestoration({ projectId }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { conditionSelector, condition } = (0, schemaComponents_1.useConditionSelector)({
        schema: (0, dataTransferSchema_1.default)({ projectId }),
        hideTimeCondition: true,
    });
    // condition に aiSearch が入っている場合、まず Segment ID のリストを取得する
    const aiSearchParam = (() => {
        var _a, _b;
        const aiSearchParam = (_b = (_a = condition === null || condition === void 0 ? void 0 : condition.aiSearch) === null || _a === void 0 ? void 0 : _a.$matchIntl) !== null && _b !== void 0 ? _b : null;
        if (!aiSearchParam || typeof aiSearchParam !== "string")
            return null;
        return aiSearchParam;
    })();
    const [aiSearchSegments, setAiSearchSegments] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (!aiSearchParam) {
            setAiSearchSegments([]);
            return;
        }
        let stale = false;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                let hitSegmentId = [];
                // Iterate at max 5 times
                for (let i = 0; i < 5; i++) {
                    const newSegments = yield (0, copilotApi_1.searchSegment)({
                        text: aiSearchParam,
                        projectId,
                        exceptSegmentId: hitSegmentId,
                    });
                    if (stale)
                        return;
                    if (newSegments.length === 0)
                        break;
                    hitSegmentId = [...hitSegmentId, ...newSegments];
                }
                setAiSearchSegments(hitSegmentId);
            }
            catch (e) {
                if (stale)
                    return;
                setAiSearchSegments([]);
            }
        }))();
        return () => {
            stale = true;
        };
    }, [aiSearchParam]);
    const mergedCondition = (0, react_1.useMemo)(() => {
        if (!aiSearchParam)
            return condition;
        return {
            segmentId: {
                $in: aiSearchSegments,
            },
        };
    }, [aiSearchParam, condition, aiSearchSegments]);
    // 次に、 Segment ID のリストを元に filter する
    const { list, loading, hasMore, refresher, fetching, reload, refresh } = (0, models_hook_1.useSegmentList)({
        projectId,
        condition: mergedCondition,
        deleted: true,
    });
    const parameter = (0, react_1.useMemo)(() => ({
        title: "削除されたファイルの回復",
        edit: {
            path: ({ segmentId }) => "",
        },
        schema: (0, schema_1.default)({ projectId }),
        backPath: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
    }), [projectId]);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [isPending, setPending] = (0, react_1.useState)(false);
    const handleRestore = (segment) => __awaiter(this, void 0, void 0, function* () {
        try {
            setPending(true);
            yield (0, helpers_1.restoreSegment)(segment);
            navigate((0, index_1.resolveRoute)("LIST_SEGMENT_SCRIPTS", {
                projectId,
                segmentId: segment.segmentId,
            }));
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setPending(false);
        }
    });
    const errorModal = (0, standard_1.useErrorModal)();
    const handleDelete = (segment) => __awaiter(this, void 0, void 0, function* () {
        try {
            setPending(true);
            yield (0, helpers_1.hardDeleteSegment)(segment);
            refresh();
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error delete segment",
                userMessage: "ゴミ箱の中のファイルを削除できませんでした",
            });
        }
        finally {
            setPending(false);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: isPending },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("p", null, "\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044"))),
        react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: list, loading: loading, hasMore: hasMore, fetching: fetching, refresher: refresher, header: conditionSelector, reload: reload, rowActions: (segment) => (react_1.default.createElement("div", { className: "d-flex gap-2" },
                react_1.default.createElement(components_1.Button, { size: "sm", onClick: () => handleRestore(segment), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u56DE\u5FA9" },
                    react_1.default.createElement("i", { className: "mdi mdi-restore" })),
                react_1.default.createElement(components_1.Button, { size: "sm", onClick: () => handleDelete(segment), variant: "danger", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u5B8C\u5168\u306B\u524A\u9664" },
                    react_1.default.createElement("i", { className: "mdi mdi-delete" })))) })));
}
exports.default = SegmentRestoration;
